package com.milta.core.localization.translations.it

import com.milta.core.localization.RouteCreationStrings

internal val RouteCreation = RouteCreationStrings(
    newRouteTitle = "Nuovo giro",
    stepDeliveries = "Consegne",
    stepDrivers = "Autisti",
    stepDistribution = "Ripartizione",
    deliveriesSummary = "%1 consegne · %2 colli",
    deliveriesSummaryOne = "1 consegna · %1 colli",
    toFixCount = "%1 da correggere",
    allAddressesCorrect = "Tutti gli indirizzi sono corretti",
    filterAll = "Tutte %1",
    filterToFix = "Da correggere %1",
    fixAddressesToContinue = "Correggi %1 indirizzi per continuare",
    fixOneAddressToContinue = "Correggi 1 indirizzo per continuare",
    continueWithDeliveries = "Continua · %1 consegne",
    continueWithOneDelivery = "Continua · 1 consegna",
    chooseAtLeastOneDriver = "Scegli almeno un autista",
    reasonMissingHouseNumber = "Numero civico mancante",
    reasonNotFound = "Indirizzo non trovato",
    reasonUnverified = "Verifica non riuscita, riprova",
    missingHouseNumberExample = "Manca il numero civico. Esempio: %1",
    notFoundHelp = "Indirizzo non trovato. Verifica la via, il numero e il codice postale.",
    unverifiedHelp = "Non è stato possibile verificare l'indirizzo per ora. Riprova tra qualche istante.",
    addToExistingHint = "Si aggiungono alle %1 consegne già nell'elenco.",
    importFileAction = "Importa un file",
    importFileHint = "Excel (.xlsx, .xls), CSV o PDF",
    manualEntryAction = "Inserimento manuale",
    manualEntryHint = "Nome, indirizzo, telefono, orario limite",
    addDeliveryTitle = "Aggiungi una consegna",
    deleteDelivery = "Elimina la consegna",
    addedFileAnalysing = "Analisi di %1 in corso…",
    addedFileFailed = "L'importazione di %1 non è riuscita. Nessuna consegna è stata aggiunta.",
    errorAddressesToFix = "Alcuni indirizzi non sono stati convalidati: correggili nell'elenco «Da correggere».",
    errorAddressesCheckRetry = "La verifica degli indirizzi non è andata a buon fine. Riprova tra qualche istante.",
    errorBatchAlreadyDispatched = "Questa ripartizione è già stata inviata agli autisti.",
    editDeliveryTitle = "Modifica la consegna",
    zoneLabel = "Zona %1",
    workloadBalanced = "Tempi di lavoro equilibrati tra gli autisti",
    workloadGap = "Differenza di tempo di lavoro tra gli autisti: %1",
    importAddedFromScan = "%1 consegne aggiunte dalla scansione",
    importAddedOneFromScan = "1 consegna aggiunta dalla scansione",
    importAddedFromPdf = "%1 consegne aggiunte dal PDF",
    importAddedOneFromPdf = "1 consegna aggiunta dal PDF",
    importAddedFromSpreadsheet = "%1 consegne aggiunte dal file Excel",
    importAddedOneFromSpreadsheet = "1 consegna aggiunta dal file Excel",
    importAddedToFixSuffix = ", di cui %1 da correggere",
    deliverySearchOpenAction = "Cerca una consegna",
    deliverySearchCount = "%1 su %2",
    deliverySearchCountToFix = "%1 su %2 da correggere",
    deliverySearchEmptyTitle = "Nessuna consegna corrispondente",
    deliverySearchEmptyToFixHint = "Nessuna consegna da correggere corrisponde. Prova in «Tutte».",
)
